/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgKybcNoBusiness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="-3 -3 34 33"
    aria-label="SvgKybcNoBusiness"
    {...props}
  >
    {props.children}
    <g filter="url(#kybc-no-business_svg__a)">
      <rect width={22.015} height={15.048} x={3.201} y={8.969} fill="#fff" rx={2.617} />
      <rect
        width={21.905}
        height={14.938}
        x={3.256}
        y={9.024}
        stroke="url(#kybc-no-business_svg__b)"
        strokeOpacity={0.5}
        strokeWidth={0.11}
        rx={2.562}
      />
    </g>
    <g filter="url(#kybc-no-business_svg__c)">
      <rect width={1.942} height={1.963} x={12.913} y={3.735} fill="#fff" rx={0.971} />
      <rect
        width={1.833}
        height={1.853}
        x={12.968}
        y={3.79}
        stroke="url(#kybc-no-business_svg__d)"
        strokeOpacity={0.5}
        strokeWidth={0.11}
        rx={0.916}
      />
    </g>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.309}
      d="m5.791 9.625 6.272-6.084a2.617 2.617 0 0 1 3.644 0l6.271 6.084"
    />
    <path
      fill="#74DBC9"
      d="M8.843 13.527a.5.5 0 0 0-.187-.141.6.6 0 0 0-.252-.05.65.65 0 0 0-.268.056.7.7 0 0 0-.213.157.7.7 0 0 0-.14.236.9.9 0 0 0-.05.298q0 .164.05.3.052.135.14.236a.611.611 0 0 0 .465.21.553.553 0 0 0 .478-.249l.425.317a.9.9 0 0 1-.373.304q-.225.099-.465.099-.271 0-.5-.085a1.2 1.2 0 0 1-.396-.242 1.1 1.1 0 0 1-.262-.387 1.3 1.3 0 0 1-.091-.503q0-.279.091-.504.094-.225.262-.383.167-.16.396-.245t.5-.085q.099 0 .203.02a1 1 0 0 1 .409.16q.095.065.17.16zm.6.556q0-.279.092-.504.095-.225.261-.383.168-.16.396-.245.23-.085.5-.085.273 0 .501.085.23.084.396.245.167.157.258.383.095.225.095.504 0 .278-.095.503-.09.226-.258.386a1.2 1.2 0 0 1-.396.243q-.229.085-.5.085-.272 0-.5-.085a1.2 1.2 0 0 1-.397-.242 1.1 1.1 0 0 1-.261-.387 1.3 1.3 0 0 1-.092-.503m.53 0q0 .164.05.3a.68.68 0 0 0 .373.39.8.8 0 0 0 .297.056.75.75 0 0 0 .294-.056.7.7 0 0 0 .23-.154.7.7 0 0 0 .143-.235.8.8 0 0 0 .053-.301.8.8 0 0 0-.053-.298.65.65 0 0 0-.373-.393.75.75 0 0 0-.294-.055.8.8 0 0 0-.298.055.687.687 0 0 0-.373.393.9.9 0 0 0-.049.298m2.316-1.158h.772l.534 1.511h.006l.537-1.511h.768v2.316h-.51v-1.777h-.007l-.608 1.777h-.39l-.585-1.777H12.8v1.777h-.51zm3.083 0h.51v2.316h-.51zm.974 0h.694l.985 1.61h.006v-1.61h.51v2.316h-.667l-1.01-1.649h-.007v1.649h-.51zm4.765 2.152q-.226.118-.471.17t-.5.053q-.273 0-.501-.085a1.2 1.2 0 0 1-.396-.242 1.1 1.1 0 0 1-.262-.387 1.3 1.3 0 0 1-.091-.503q0-.279.091-.504.095-.225.262-.383.166-.16.396-.245.229-.085.5-.085.279 0 .51.068.237.066.413.23l-.36.392a.7.7 0 0 0-.236-.164.8.8 0 0 0-.327-.055.8.8 0 0 0-.297.055.685.685 0 0 0-.373.393.9.9 0 0 0-.05.298q0 .164.05.3.053.135.147.236a.7.7 0 0 0 .226.154.8.8 0 0 0 .297.056q.168 0 .288-.037.121-.039.193-.078v-.376h-.415v-.471h.906zm-10.517 2.414a.35.35 0 0 0-.17-.115.53.53 0 0 0-.314-.026.4.4 0 0 0-.111.042.23.23 0 0 0-.085.072.2.2 0 0 0-.033.112q0 .105.079.16a.8.8 0 0 0 .196.095q.12.039.258.078.138.04.255.111.122.073.2.194.079.12.079.323a.74.74 0 0 1-.072.337.7.7 0 0 1-.197.24.8.8 0 0 1-.284.14q-.16.046-.34.046-.226 0-.42-.07a1.1 1.1 0 0 1-.36-.221l.364-.4a.55.55 0 0 0 .57.206.4.4 0 0 0 .114-.045.2.2 0 0 0 .081-.076.2.2 0 0 0 .033-.107.19.19 0 0 0-.082-.164.7.7 0 0 0-.2-.105 6 6 0 0 0-.26-.085 1.2 1.2 0 0 1-.263-.114.65.65 0 0 1-.202-.19.55.55 0 0 1-.079-.31q0-.187.072-.328a.7.7 0 0 1 .196-.236.9.9 0 0 1 .285-.14q.16-.05.33-.05.197.001.38.056.183.056.33.187zm.61.592q0-.279.091-.504.094-.225.262-.383.166-.16.396-.245.228-.085.5-.085t.5.085q.23.084.396.245.168.157.259.383.095.225.095.504 0 .277-.095.504-.091.225-.259.386a1.2 1.2 0 0 1-.396.242q-.228.085-.5.085t-.5-.085a1.2 1.2 0 0 1-.396-.242 1.1 1.1 0 0 1-.262-.386 1.3 1.3 0 0 1-.092-.504m.53 0q0 .164.048.3a.681.681 0 0 0 .373.39.8.8 0 0 0 .298.055q.164 0 .294-.055a.7.7 0 0 0 .23-.154.7.7 0 0 0 .143-.235.8.8 0 0 0 .053-.301.8.8 0 0 0-.053-.298.65.65 0 0 0-.373-.393.75.75 0 0 0-.294-.055.8.8 0 0 0-.298.055.687.687 0 0 0-.373.393.9.9 0 0 0-.049.298m2.191 0q0-.279.092-.504.095-.225.261-.383.168-.16.396-.245.23-.085.5-.085.273 0 .501.085.23.084.396.245.167.157.259.383.095.225.095.504 0 .277-.095.504-.091.225-.259.386a1.2 1.2 0 0 1-.396.242q-.229.085-.5.085-.272 0-.5-.085a1.2 1.2 0 0 1-.397-.242 1.1 1.1 0 0 1-.261-.386 1.3 1.3 0 0 1-.092-.504m.53 0q0 .164.05.3t.146.236a.7.7 0 0 0 .226.154.8.8 0 0 0 .298.055.75.75 0 0 0 .294-.055.7.7 0 0 0 .23-.154.7.7 0 0 0 .143-.235.8.8 0 0 0 .053-.301.8.8 0 0 0-.053-.298.65.65 0 0 0-.373-.393.75.75 0 0 0-.294-.055.8.8 0 0 0-.298.055.684.684 0 0 0-.373.393.9.9 0 0 0-.049.298m2.316-1.158h.694l.985 1.61h.006v-1.61h.51v2.316H18.3l-1.01-1.649h-.007v1.649h-.51z"
    />
    <defs>
      <linearGradient
        id="kybc-no-business_svg__b"
        x1={5.573}
        x2={24.266}
        y1={14.017}
        y2={14.168}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="kybc-no-business_svg__d"
        x1={13.122}
        x2={14.772}
        y1={4.394}
        y2={4.403}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <filter
        id="kybc-no-business_svg__a"
        width={38.504}
        height={31.538}
        x={-5.044}
        y={0.724}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={4.122} />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4313_6459" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={2.748} dy={2.748} />
        <feGaussianBlur stdDeviation={2.748} />
        <feColorMatrix values="0 0 0 0 0.102795 0 0 0 0 0.795833 0 0 0 0 0.54634 0 0 0 0.5 0" />
        <feBlend in2="effect1_backgroundBlur_4313_6459" result="effect2_dropShadow_4313_6459" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow_4313_6459" result="shape" />
      </filter>
      <filter
        id="kybc-no-business_svg__c"
        width={18.432}
        height={18.452}
        x={4.668}
        y={-4.509}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={4.122} />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4313_6459" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={2.748} dy={2.748} />
        <feGaussianBlur stdDeviation={2.748} />
        <feColorMatrix values="0 0 0 0 0.102795 0 0 0 0 0.795833 0 0 0 0 0.54634 0 0 0 0.5 0" />
        <feBlend in2="effect1_backgroundBlur_4313_6459" result="effect2_dropShadow_4313_6459" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow_4313_6459" result="shape" />
      </filter>
    </defs>
  </svg>
)
